import { ReactNode } from 'react';
import cn from 'classnames';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import Title from '@creditflowresearch/uilib/Title';
import { IconComponentType } from '@creditflowresearch/uilib/Icon';

import spacesStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';
import styles from './titleWithIcon.module.scss';

interface ITitleWithIconProps {
  title: ReactNode,
  dataTest: string,
  icon: IconComponentType,
  iconPosition?: 'left' | 'right',
  tooltipContent?: ReactNode,
  className?: string,
}

const TitleWithIcon = ({
  title,
  dataTest,
  icon: IconComponent,
  iconPosition = 'right',
  tooltipContent,
  className,
}: ITitleWithIconProps) => {
  const isRight = iconPosition === 'right';

  const renderIcon = () => {
    if (!IconComponent) {
      return null;
    }

    const iconNode = <IconComponent size={ 12 } className={ styles.icon } />;

    if (tooltipContent) {
      return (
        <Tooltip content={ tooltipContent } containerClassName={ styles.iconTooltip }>
          { iconNode }
        </Tooltip>
      );
    }

    return iconNode;
  };

  return (
    <div className={ cn(styles.titleContainer, className) } data-test={ `${ dataTest }Title` }>
      { !isRight ? renderIcon() : null }
      <Title title={ title } className={ spacesStyles.mn } />
      { isRight ? renderIcon() : null }
    </div>
  );
};

export default TitleWithIcon;
